export function appendTextPart(parts, event) {
  const text = String(event.text ?? '')
  if (!text) return parts
  const attemptId = event.attempt_id ?? null
  const prior = parts.at(-1)
  if (prior?.type === 'markdown' && prior.attempt_id === attemptId) {
    return [...parts.slice(0, -1), { ...prior, text: prior.text + text }]
  }
  return [...parts, { type: 'markdown', text, attempt_id: attemptId }]
}

export function upsertAccessPart(parts, block, event) {
  const index = parts.findIndex(
    (part) => part.type === 'integration_access_request' && part.review_id === block.review_id,
  )
  const next = { ...block, attempt_id: event.attempt_id ?? null }
  if (index < 0) return [...parts, next]
  return parts.map((part, i) => (i === index ? next : part))
}

export function partsAfterRestart(parts, event) {
  const attemptId = event.attempt_id ?? null
  if (!attemptId) return parts.filter((part) => part.type !== 'markdown')
  return parts.filter((part) => part.attempt_id !== attemptId)
}
